import { z } from "zod";
import { GoalBasedFinancialPlanAssetLiabilityId } from "../types";
const ProjectionDate = z.object({
    date: z.string(), // yyyy-MM-dd
    market_value: z.number(),
    upper_bound: z.number(),
    lower_bound: z.number(),
});
const AccountSummary = z.object({
    account_id: GoalBasedFinancialPlanAssetLiabilityId,
    current_market_value: z.number(),
    retirement_market_value: z.number().nullable(),
    end_of_plan_market_value: z.number(),
});
export const GoalBasedFinancialPlanProjectionResponse = z.object({
    unique_projection_id: z.string(),
    projections: z.array(ProjectionDate),
    account_summary: z.array(AccountSummary),
    probability_of_success: z.number(),
});
export const GoalBasedFinancialPlanProjectionUnderwaterExceptionResponse = z.object({
    underwater_accounts: z.array(GoalBasedFinancialPlanAssetLiabilityId),
});
//# sourceMappingURL=types.js.map